console.log('[TabbedCollection] Script loaded');
console.log('[TabbedCollection] Already defined?', customElements.get('tabbed-featured-collection'));
console.log('[TabbedCollection] Elements in DOM:', document.querySelectorAll('tabbed-featured-collection').length);

if (!customElements.get('tabbed-featured-collection')) {
  class TabbedFeaturedCollection extends HTMLElement {
    constructor() {
      super();
      console.log('[TabbedCollection] Constructor called');
      this.selectors = {
        tabButtons: ['.tab-button'],
        tabPanels: ['.tab-panel'],
        carouselNavs: ['.carousel-nav'],
        viewAllLink: '.view-all-link',
        productLists: ['.product-list'],
        loadingPlaceholders: ['.loading-placeholder']
      };
    }

    connectedCallback() {
      console.log('[TabbedCollection] connectedCallback fired');
      this.init();
    }

    init() {
      // Check if Foxify utils are available, fallback to manual selection
      if (window.Foxify && window.Foxify.Utils && window.Foxify.Utils.queryDomNodes) {
        this.domNodes = window.Foxify.Utils.queryDomNodes(this.selectors, this);
      } else {
        // Manual fallback
        this.domNodes = {
          tabButtons: Array.from(this.querySelectorAll('.tab-button')),
          tabPanels: Array.from(this.querySelectorAll('.tab-panel')),
          carouselNavs: Array.from(this.querySelectorAll('.carousel-nav')),
          viewAllLink: this.querySelector('.view-all-link'),
          productLists: Array.from(this.querySelectorAll('.product-list')),
          loadingPlaceholders: Array.from(this.querySelectorAll('.loading-placeholder'))
        };
      }

      this.collections = this.dataset.collections ? this.dataset.collections.split(',') : [];
      this.labels = this.dataset.labels ? this.dataset.labels.split(',') : [];
      this.enableCarousel = this.dataset.enableCarousel === 'true';
      this.grid = parseInt(this.dataset.grid) || 4;
      this.rows = parseInt(this.dataset.rows) || 1;
      this.productLimit = parseInt(this.dataset.productLimit) || 20;
      this.sectionId = this.dataset.sectionId;
      this.activeIndex = 0;

      console.log('Initialized tabbed collection:', {
        collections: this.collections,
        labels: this.labels,
        tabButtons: this.domNodes.tabButtons.length,
        tabPanels: this.domNodes.tabPanels.length
      });

      this.bindEvents();
      this.initializeCarousel();
      this.updateViewAllLink();
      this.updateTabUnderline();
    }

    bindEvents() {
      // Tab button clicks
      this.domNodes.tabButtons.forEach((button, index) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          console.log('Tab button clicked:', index, button);
          this.switchToTab(index);
        });
      });

      // Carousel navigation
      this.domNodes.carouselNavs.forEach(nav => {
        nav.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleCarouselNav(e.target.closest('[data-carousel-nav]'));
        });
      });

      // Keyboard navigation
      this.addEventListener('keydown', this.handleKeydown.bind(this));

      // Window resize handler for underline repositioning
      this.resizeHandler = () => this.updateTabUnderline();
      window.addEventListener('resize', this.resizeHandler);
    }

    switchToTab(index) {
      if (index === this.activeIndex || index >= this.collections.length) return;

      console.log('Switching to tab:', index, 'Collection:', this.collections[index]);

      // Update tab states
      this.domNodes.tabButtons.forEach((button, i) => {
        button.classList.toggle('active', i === index);
        button.setAttribute('aria-selected', i === index);
      });

      // Update panel states
      this.domNodes.tabPanels.forEach((panel, i) => {
        panel.classList.toggle('active', i === index);
      });

      // Destroy current carousel if it exists
      this.destroyCarousel();

      this.activeIndex = index;

      // Always reinitialize carousel for the new active panel
      this.initializeCarousel();

      // Update view all link
      this.updateViewAllLink();

      // Update tab underline position
      this.updateTabUnderline();

      // Dispatch custom event
      this.dispatchEvent(new CustomEvent('tabChanged', {
        detail: { 
          activeIndex: index, 
          collection: this.collections[index],
          label: this.labels[index]
        }
      }));
    }


    initializeCarousel() {
      if (!this.enableCarousel) return;

      const activePanel = this.domNodes.tabPanels[this.activeIndex];
      if (!activePanel) return;

      const carousel = activePanel.querySelector('.carousel');
      if (!carousel) return;

      // If Owl was previously initialised on this panel (e.g. at page load when the
      // panel was display:none and Owl measured zero widths), tear it down first so
      // theme.loadCarousels can re-init now that the panel is visible and widths are real.
      if (typeof $ !== 'undefined') {
        try {
          const existing = $(carousel).data('owl.carousel');
          if (existing) existing.destroy();
        } catch (e) {
          console.warn('[TabbedCollection] could not destroy stale Owl:', e);
        }
      }

      // Use existing theme carousel initialization
      if (window.theme && window.theme.loadCarousels) {
        theme.loadCarousels(activePanel);
      }

      // Also load product block images
      if (window.theme && window.theme.ProductBlockManager) {
        theme.ProductBlockManager.loadImages(activePanel);
      }
    }

    destroyCarousel() {
      if (!this.enableCarousel) return;

      const activePanel = this.domNodes.tabPanels[this.activeIndex];
      if (!activePanel) return;

      const carousel = activePanel.querySelector('.carousel');
      if (!carousel) return;

      try {
        if (typeof $ !== 'undefined') {
          const owlCarousel = $(carousel).data('owl.carousel');
          if (owlCarousel) {
            owlCarousel.destroy();
          }
        }
      } catch (e) {
        console.warn('Could not destroy carousel:', e);
      }
    }

    handleCarouselNav(navElement) {
      if (!this.enableCarousel || !navElement) return;

      const activePanel = this.domNodes.tabPanels[this.activeIndex];
      if (!activePanel) return;

      const carousel = activePanel.querySelector('.owl-carousel');
      if (!carousel) return;

      try {
        if (typeof $ === 'undefined') return;
        const owlCarousel = $(carousel).data('owl.carousel');
        if (!owlCarousel) return;

        const direction = navElement.dataset.carouselNav || (navElement.classList.contains('prev') ? 'prev' : 'next');
        if (direction === 'prev') {
          owlCarousel.prev();
        } else if (direction === 'next') {
          owlCarousel.next();
        }
      } catch (e) {
        console.warn('Could not navigate carousel:', e);
      }
    }

    updateViewAllLink() {
      if (!this.domNodes.viewAllLink) return;

      const currentCollection = this.collections[this.activeIndex];
      if (currentCollection) {
        this.domNodes.viewAllLink.href = `/collections/${currentCollection}`;
      }
    }

    updateTabUnderline() {
      const tabsContainer = this.querySelector('.tabbed-collection-tabs');
      const activeButton = this.domNodes.tabButtons[this.activeIndex];
      
      if (!tabsContainer || !activeButton) return;

      const containerRect = tabsContainer.getBoundingClientRect();
      const buttonRect = activeButton.getBoundingClientRect();
      
      const left = buttonRect.left - containerRect.left + 24; // Account for button padding
      const width = buttonRect.width - 48; // Account for button padding on both sides
      
      // Use CSS custom properties to animate the underline
      tabsContainer.style.setProperty('--underline-left', `${left}px`);
      tabsContainer.style.setProperty('--underline-width', `${width}px`);
      
      // Update the CSS to use these custom properties
      const style = document.createElement('style');
      style.textContent = `
        .tabbed-collection-tabs::after {
          left: var(--underline-left, 0);
          width: var(--underline-width, 0);
        }
      `;
      
      // Remove previous style if exists
      const existingStyle = document.getElementById('tab-underline-style');
      if (existingStyle) {
        existingStyle.remove();
      }
      
      style.id = 'tab-underline-style';
      document.head.appendChild(style);
    }

    handleKeydown(e) {
      // Left/Right arrow keys for tab navigation
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        
        let newIndex = this.activeIndex;
        if (e.key === 'ArrowRight') {
          newIndex = (this.activeIndex + 1) % this.collections.length;
        } else {
          newIndex = this.activeIndex - 1;
          if (newIndex < 0) newIndex = this.collections.length - 1;
        }
        
        this.switchToTab(newIndex);
        this.domNodes.tabButtons[newIndex].focus();
      }
    }

    disconnectedCallback() {
      this.destroyCarousel();
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
    }
  }

  customElements.define('tabbed-featured-collection', TabbedFeaturedCollection);
}


// Initialize existing tabbed collections on page load
document.addEventListener('DOMContentLoaded', function() {
  const tabbedCollections = document.querySelectorAll('tabbed-featured-collection');
  tabbedCollections.forEach(collection => {
    if (!collection.initialized) {
      collection.initialized = true;
    }
  });
});

// Shopify section reload handling
document.addEventListener('shopify:section:load', function(e) {
  const tabbedCollections = e.target.querySelectorAll('tabbed-featured-collection');
  tabbedCollections.forEach(collection => {
    if (collection.init) {
      collection.init();
    }
  });
});

document.addEventListener('shopify:section:unload', function(e) {
  const tabbedCollections = e.target.querySelectorAll('tabbed-featured-collection');
  tabbedCollections.forEach(collection => {
    if (collection.disconnectedCallback) {
      collection.disconnectedCallback();
    }
  });
});